import { createSelector } from '@reduxjs/toolkit';
import { selfClientSelector } from './self';

const clientsSelector = createSelector(selfClientSelector, (clients) => clients.clients);

export default clientsSelector;
